import { APIClient, APIClientOptions } from '../../APIClient'
import { ApiMethod } from '../../types'

const STARTS_WITH_HTTP = /^http/

interface FetcherOptions {
  body?: any
  method?: ApiMethod
  query?: object
  signal?: AbortSignal
}

export default function fetcher(url: string, options: FetcherOptions = {}) {
  const { body, method = 'GET', query, signal } = options
  const _options: APIClientOptions = {
    ...(body && { body }),
    ...(query && { queryParams: query }),
    ...(signal && { signal }),
  }

  const isBase = STARTS_WITH_HTTP.test(url)
  if (isBase) {
    _options.apiBaseURL = url
  }

  return APIClient.makeAPICall(method, isBase ? '' : url, _options)
}
